import {CompletionTrackingAction} from './completionTrackingActions';
import {trackingAction} from './itemsTrackingActions';

export type CompletionTrackingState = boolean;

export function createCompletionTrackingState(startState: CompletionTrackingState) {
  return (state: CompletionTrackingState = startState, action: any): CompletionTrackingState => {
    switch (action.type) {
      case CompletionTrackingAction.Tracking_Completed:
        return true;
      case trackingAction.Tracking_ResetProgress:
        return false;
      default:
        return state;
    }
  };
}
